import React from 'react'
import styles from './NotificationDocket.module.scss'
import clsx from 'clsx'
import { FilterStatus } from '../../Types/Enums'
import { Button as TDSButton } from '@instacart/tds'

type NotificationDocketProps = {
  count: number
  currentFilter: FilterStatus
  onClick: () => void
}

export const NotificationDocket: React.FC<NotificationDocketProps> = ({
  count,
  currentFilter,
  onClick,
}) => {
  const oppositeFilter =
    currentFilter === FilterStatus.Active ? FilterStatus.Upcoming : FilterStatus.Active

  const label = `${oppositeFilter} order${count === 1 ? '' : 's'} need${
    count === 1 ? 's' : ''
  } to be confirmed`
  const buttonLabel = `View ${oppositeFilter} Orders`

  return (
    <div className={clsx('notificationDocket', 'docket', styles.notificationDocket)}>
      <div className={clsx('docket-inner', styles.notificationDocketInner)}>
        <div className={styles.notificationDocketContent}>
          <div className={styles.orderCount}>{count}</div>
          <p>{label}</p>
        </div>
        <div className={styles.notificationButton}>
          <TDSButton onClick={onClick} variant="primary" fullWidth>
            {buttonLabel}
          </TDSButton>
        </div>
      </div>
    </div>
  )
}
